// Libs
import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { IInvoicePdf } from '~/utils/interface/invoice';
import { formatCurrencyUSD, formatDate } from '~/utils/helper/common';
import { DateFormatEnum } from '~/utils/enum/common';
// Styles, images, icons
import { styles } from './styles';
import { images } from '~/assets';

type Props = { invoicePdf: IInvoicePdf };

const InvoicePdf = (props: Props) => {
  //#region Destructuring Props
  const { invoicePdf } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/invoice']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.mainContainer}>
          <View style={styles.header}>
            <View style={styles.viewOneHeader}>
              <Image style={styles.logo} src={images.commonLogo} />

              <View style={styles.viewRightOneHeader}>
                <Text style={[styles.titleTitle, styles.viewLeft]}>{t('invoice_pdf_title')}</Text>

                <Text style={[styles.textLabel, styles.viewLeft]}>{t('invoice_pdf_sub_title')}</Text>

                <Text style={[styles.textContent, styles.viewLeft]}>{t('invoice_pdf_address')}</Text>
              </View>
            </View>

            <View style={styles.viewLine} />

            <View style={styles.viewTwoHeader}>
              <View style={styles.viewLeftTwoHeader}>
                <Text style={styles.textSubTitle}>{t('invoice_pdf_bill_to')}</Text>
                <Text style={styles.textLabel}>{invoicePdf?.clientName}</Text>
                {/* <View style={styled.height(6)} />
                <Text style={styles.textContent}>{invoicePdf?.clientAddress}</Text> */}
              </View>

              <View style={styles.viewRightTwoHeader}>
                <View style={styles.viewItemHeaderTwo}>
                  <Text style={[styles.textLabel, styles.viewLabelTwo]}>{t('invoice_pdf_order_number')}</Text>
                  <Text style={styles.textContent}>{invoicePdf?.invoiceNumber}</Text>
                </View>

                <View style={styles.viewItemHeaderTwo}>
                  <Text style={[styles.textLabel, styles.viewLabelTwo]}>{t('invoice_pdf_due_date')}</Text>
                  <Text style={styles.textContent}>
                    {`${formatDate(invoicePdf?.dueDate, DateFormatEnum.MM_DD_YYYY)}`}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <View style={styles.tableContainer}>
            <Text style={styles.textSubTitle}>{t('invoice_pdf_invoices')}</Text>

            <View style={styles.tableHeader}>
              <Text style={styles.tableHeaderCell}>{t('invoice_pdf_name')}</Text>
              <Text style={styles.tableHeaderCell}>{t('invoice_pdf_table_discount')}</Text>
              <Text style={styles.tableHeaderCell}>{t('invoice_pdf_rental_price')}</Text>
              <Text style={styles.tableHeaderCell}>{t('invoice_pdf_labor_cost')}</Text>
              <Text style={styles.tableHeaderCell}>{t('invoice_pdf_quantity')}</Text>
              <Text style={styles.tableHeaderCell}>{t('invoice_pdf_total')}</Text>
            </View>
            {invoicePdf?.invoices &&
              invoicePdf?.invoices.length > 0 &&
              invoicePdf?.invoices.map((item) => (
                <View key={item.id} style={styles.tableRow}>
                  <Text style={styles.tableCell}>{item?.name}</Text>
                  <Text style={styles.tableCell}>
                    {formatCurrencyUSD({ value: item?.discountRate, showDecimal: true })}
                  </Text>
                  <Text style={styles.tableCell}>{formatCurrencyUSD({ value: item?.price, showDecimal: true })}</Text>
                  <Text style={styles.tableCell}>
                    {formatCurrencyUSD({ value: item?.laborCost, showDecimal: true })}
                  </Text>
                  <Text style={styles.tableCell}>{item?.quantity || 0}</Text>
                  <Text style={styles.tableCell}>{formatCurrencyUSD({ value: item?.total, showDecimal: true })}</Text>
                </View>
              ))}
          </View>

          <View style={styles.viewTotalContainer}>
            <View style={styles.viewAdjustment}></View>

            <View style={styles.viewTotalContent}>
              <Text style={styles.textSubTitle}>{t('invoice_pdf_total')}</Text>
              <View style={styles.viewAdjustmentContainer}>
                <View style={styles.viewAdjustmentItem}>
                  <Text style={styles.viewAdjustmentLabel}>{t('invoice_pdf_subtotal')}</Text>
                  <Text>{formatCurrencyUSD({ value: invoicePdf?.subtotal, showDecimal: true })}</Text>
                </View>

                <View style={styles.viewAdjustmentItem}>
                  <Text style={styles.viewAdjustmentLabel}>{t('invoice_pdf_tax')}</Text>
                  <Text>{formatCurrencyUSD({ value: invoicePdf?.taxAmount, showDecimal: true })}</Text>
                </View>

                <View style={styles.viewAdjustmentItem}>
                  <Text style={styles.viewAdjustmentLabel}>{t('invoice_pdf_discount')}</Text>
                  <Text>{formatCurrencyUSD({ value: invoicePdf?.discountRate, showDecimal: true })}</Text>
                </View>

                <View style={styles.viewAdjustmentItem}>
                  <Text style={styles.viewAdjustmentLabel}>{t('invoice_pdf_total')}</Text>
                  <Text style={styles.viewAdjustmentLabel}>
                    {formatCurrencyUSD({ value: invoicePdf?.total, showDecimal: true })}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* <View style={styles.viewSignature}>
            <View style={styles.viewSignatureClient}>
              <Text style={styles.textSubTitle}>{t('quote_pdf_client_signature')}</Text>
              <Text style={{ fontSize: 40, opacity: 0 }}>{PDF_POSITION_PLACEHOLDER_TO_SIGNING}</Text>
            </View>
          </View> */}
        </View>
      </Page>
    </Document>
  );
};

const styled = {
  height: (height: number) => ({
    height: height,
  }),
};

export default InvoicePdf;
